import React from 'react';

export const VolLocNumModal = {
  title: 'Previous Volcano Number',
  body: (
    <div>
      <p>
        The volcano numbering system, developed by the Catalog of Active
        Volcanoes of the World in the late 1930s and used in all their volumes,
        is geographic and hierarchical. The first two numerals identify region,
        the next two identify subregion, and the last two or three
        (after the hyphen) identify individual volcanoes in that subregion.
        For more information on the volcano id, please visit Smithsonian
        Institution, Global Volcanism Program. This numbering system was retired
        and replaced on September 30, 2013.
      </p>
    </div>
  ),
};
